import fetch from "common/js/fetch";
// 供应商端账目统计
export function getSupplier(params) {
    return fetch("/core/v1/payment_goods/supplier_statistic", params);
  }
// 供应商端一键结算结算
export function getSupplierDisposable(params) {
    return fetch("/core/v1/payment_goods/supplier_disposable_settle", params);
}
// 供应商端提交结算
export function getSupplierApply(params) {
  return fetch("/core/v1/payment_goods/disposable_settle_apply", params);
}
//供应商端list列表
  export function getSupplierpage(params) {
    return fetch("/core/v1/payment_goods/supplier_page", params);
}
 //供应商端单订单结算
 export function getSettleApply(params) {
  return fetch("/core/v1/payment_goods/settle_apply", params);
}
 //供应商端我已退款
 export function getSupplierRefunded(params) {
  return fetch("/core/v1/payment_goods/supplier_refunded", params);
}
// 供应商端货款订单详情
export function getDetail(params) {
  return fetch("/core/v1/payment_goods/payment_goods_detail", params);
}
// 供应商端修改货款明细
export function getModify(params) {
  return fetch("/core/v1/payment_goods/modify", params);
}


// WEBPACK FOOTER //
// ./src/api/index/api.js